import { EventType } from '../enums';
import { IEvent } from '@studyportals/event-aggregation-service-interface';

export class BestfitRecalculatedEvent implements IEvent {
	public static EventType = EventType.BESTFIT_RECALCULATED;

	public readonly timestamp: Date;
	public readonly eventType = BestfitRecalculatedEvent.EventType;

	constructor() {
		this.timestamp = new Date();
	}
}
